<div class="">
  <app-sidebar [hidden]="isLogin"></app-sidebar>
  <div class="div-nav-apart" [ngClass]="{ 'div-nav-apart-login': isLogin }">
    <div class="main-panel">
      <app-nav-header [hidden]="isLogin"></app-nav-header>
      <div class="content-wrapper">
          <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
<app-confirm-dialog></app-confirm-dialog>  





<!-- <div class="wrapper">
  <app-sidebar [hidden]="isLogin"></app-sidebar>
    <div class="main-panel">
      <app-nav-header [hidden]="isLogin"></app-nav-header>
      <div class="content-wrapper">
          <router-outlet></router-outlet>
      </div>
    </div>
</div>
<app-confirm-dialog></app-confirm-dialog>   -->
